export default {
  user_profile: (state, data) => {
    state.user_profile = data
  },
  logout: (state, data) => {
    state.auth_info.sessionid = ''
  },
  tmp_task: (state, data) => {
    if (data) {
      state.tmp_task = Object.assign({}, state.tmp_task, data)
    } else {
      state.tmp_task = {}
    }
    localStorage.setItem('tmp_task', JSON.stringify(state.tmp_task))
  },
  tmp_topic: (state, data) => {
    if (data) {
      state.tmp_topic = Object.assign({}, state.tmp_topic, data)
    } else {
      state.tmp_topic = {}
    }
    localStorage.setItem('tmp_topic', JSON.stringify(state.tmp_topic))
  }
}
